import { rgba } from 'polished'
import styled from 'styled-components'

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  transition: all 250ms linear;

  padding-top: 0;
  /*
   * O respiro ate a faixa dos profissionais e PADDING, nao margin, de
   * proposito. Como margin ele ficava fora do fundo do cabecalho e fora da
   * altura medida pelo ResizeObserver: a faixa laranja grudava 12px acima do
   * lugar certo e, ao rolar, a grade aparecia por essa fresta entre as duas.
   * Como padding, o fundo cobre e a altura publicada ja inclui o espaco.
   */
  padding-bottom: 6px;
  background: ${(props) => props.theme.colors.background};

  &.hidden {
    height: 0px;
    overflow: hidden;
    padding-bottom: 0;
  }
`

/** Barra de acoes: intervalo a esquerda, botoes a direita, numa caixa so. */
export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  padding: 5px 12px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px ${(props) => rgba(props.theme.colors.black, 0.06)};

  &.fixed {
    position: fixed;
    z-index: 30;
    width: calc(100% - 142px);
    margin: 20px 0 0 110px;
    left: 0;
    top: 0;
  }
`

export const DateBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

export const Title = styled.h1`
  color: ${(props) => props.theme.colors.gray[800]};
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
`

export const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`

/**
 * Botao da barra da agenda. O contorno e o padrao; so a acao principal
 * (Pre Agendamento) vem preenchida, para nao competirem entre si como
 * acontecia quando os quatro eram laranja solido.
 */
export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  max-width: ${(props) => props.size || 'none'};
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 10px;
  background: #fff;
  color: ${(props) => props.theme.colors.gray[800]};
  font-size: 14px;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  transition: all 150ms ease;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${(props) => props.theme.colors.scale[400]};
    color: ${(props) => props.theme.colors.scale[600]};
  }
  &:active {
    transform: scale(0.97);
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.scale[300]};
  }

  ${(props) =>
    props.$primary &&
    `
    background: ${props.theme.colors.scale[500]};
    border-color: ${props.theme.colors.scale[500]};
    color: #fff;
    font-weight: 600;

    &:hover {
      background: ${props.theme.colors.scale[600]};
      border-color: ${props.theme.colors.scale[600]};
      color: #fff;
    }
  `}
`
